import { StyleSheet } from 'react-native';

import { Color, FontFamily, FontSize } from '@/styles/GlobalStyles';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.gray[50],
    marginTop: 16,
    gap: 16,
    paddingHorizontal: '9%',
    paddingBottom: 32,
    overflowX: 'auto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  infoScreen: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 4,
  },
  name: {
    color: Color.gray[200],
    fontFamily: FontFamily.regular,
    fontSize: FontSize.xs,
    lineHeight: 24,
    textTransform: 'uppercase',
  },
  title: {
    color: Color.darkSlateGray_100,
    fontFamily: FontFamily.semiBold,
    fontSize: FontSize.lg,
    lineHeight: 24,
  },
  dashboardContainer: {
    flex: 1,
    alignItems: 'flex-start',
    gap: 16,
    alignSelf: 'stretch',
    width: '100%',
    minHeight: 'auto',
  },
  filterWrapper: {
    gap: 16,
    width: '100%',
  },
  filterSectionTitle: {
    fontSize: 14,
    color: Color.darkSlateGray_100,
    fontFamily: FontFamily.semiBold,
    marginBottom: 8,
  },
  filterContainer: {
    flexDirection: 'row',
    gap: 12,
    width: '100%',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    backgroundColor: Color.gray.white,
    padding: 16,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  filterGroup: {
    gap: 6,
  },
  filterItemDate: {
    flexGrow: 2,
    flexBasis: 340,
    minWidth: 300,
  },
  filterItemForm: {
    flexGrow: 2,
    flexBasis: 260,
    minWidth: 220,
  },
  filterItemStatus: {
    flexGrow: 1,
    flexBasis: 200,
    minWidth: 180,
  },
  filterLabel: {
    fontSize: 12,
    color: Color.gray[300],
    fontFamily: FontFamily.regular,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  dateRangeContainer: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'flex-end',
    width: '100%',
  },
  dateField: {
    flex: 1,
    minWidth: 140,
  },
  input: {
    backgroundColor: Color.gray[50],
    paddingHorizontal: 14,
    borderRadius: 8,
    width: '100%',
    borderWidth: 1,
    borderColor: Color.gray[100],
    fontFamily: FontFamily.regular,
    fontSize: FontSize.sm,
    height: 64,
    justifyContent: 'center',
  },
});
